export default __webpack_public_path__ + "static/media/results-bg.78cc7040.png";